import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const MarketOverview = ({ topCryptos }) => {
  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-md border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl md:text-2xl font-bold text-foreground">Market Overview</h3>
        <button className="text-sm md:text-base text-primary hover:text-primary/80 font-medium transition-colors">
          View Markets
        </button>
      </div>
      <div className="space-y-3">
        {topCryptos?.map((crypto) => {
          const isPositive = crypto?.change24h >= 0;
          return (
            <div 
              key={crypto?.id} 
              className="flex items-center gap-4 p-4 bg-muted rounded-lg hover:bg-muted/80 transition-colors cursor-pointer"
            >
              <Image 
                src={crypto?.icon} 
                alt={crypto?.iconAlt}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-semibold text-foreground">
                  {crypto?.name}
                </p>
                <p className="text-xs md:text-sm text-muted-foreground">
                  {crypto?.symbol}
                </p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-sm md:text-base font-bold text-foreground whitespace-nowrap">
                  ${crypto?.price?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
                <div className={`flex items-center justify-end gap-1 ${isPositive ? 'text-success' : 'text-error'}`}>
                  <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={14} />
                  <span className="text-xs md:text-sm font-medium whitespace-nowrap">
                    {isPositive ? '+' : ''}{crypto?.change24h?.toFixed(2)}%
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MarketOverview;